import React, {Component} from 'react';
import 'components/Topbar.scss';
import Typography from '@material-ui/core/Typography';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import LoginRegisterComponent from 'components/Auth/LoginRegister';
import {withTranslation} from 'react-i18next';
import LanguageSelector from 'components/LanguageSelector';
import Context from 'utils/Context';
import Link from 'components/Link';

import cuultLogo from 'assets/logos-cuult/logo-cuult-u.svg';

class Topbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorMenuEl: null,
      loginRegisterOpen: false,
    };
    this.handleIconClick = this.handleIconClick.bind(this);
    this.handleMenuClose = this.handleMenuClose.bind(this);
    this.handleDisconnect = this.handleDisconnect.bind(this);
    this.handleMenuClick = this.handleMenuClick.bind(this);
    this.handleLoginRegisterClose = this.handleLoginRegisterClose.bind(this);
    this.handleLoginRegisterOpen = this.handleLoginRegisterOpen.bind(this);
  }
  componentDidMount() {
    this.context.ed.addEventListener('loginRegisterOpen', this.handleLoginRegisterOpen);
  }
  componentWillUnmount() {
    this.context.ed.removeEventListener('loginRegisterOpen', this.handleLoginRegisterOpen);
  }
  handleLoginRegisterClose() {
    this.setState({loginRegisterOpen: false});
  }
  handleLoginRegisterOpen() {
    this.setState({loginRegisterOpen: true});
  }
  handleIconClick(e) {
    if (this.context.appState.user.email) {
      this.setState({anchorMenuEl: e.currentTarget});
    } else {
      this.setState({loginRegisterOpen: !this.state.loginRegisterOpen});
    }
  }
  handleMenuClose() {
    this.setState({anchorMenuEl: null});
  }
  handleMenuClick(e) {
    let url = e.target.getAttribute('href');
    this.handleMenuClose();
    this.context.goTo(url);
  }
  handleDisconnect() {
    this.context.methods.logout(this.handleMenuClose);
  }
  render() {
    const {appState, methods} = this.context;
    let user = appState.user;
    const {t} = this.props;
    return (
      <AppBar position="static" className="top-bar">
        <Toolbar>
          {appState.canDisplayNews && (
            <>
              {['xs', 'sm'].indexOf(appState.screenSize) === -1 && (
                <Typography variant="h6" className="accueil-top-bar-title">
                  <Link url="/">
                    <span dangerouslySetInnerHTML={{__html: appState.conf.BRAND_LINE}}></span>
                  </Link>
                </Typography>
              )}
              {['xs', 'sm'].indexOf(appState.screenSize) !== -1 && (
                <Typography variant="h6" className="accueil-top-bar-title">
                  <Link url="/">
                    <img src={cuultLogo} width={32} alt="cuult logo" /> <br />
                    <span className="accueil-top-bar-brand-subtitle">Powered by The 25th hour</span>
                  </Link>
                </Typography>
              )}
            </>
          )}
          {!appState.canDisplayNews && <Typography variant="h6" className="accueil-top-bar-title"></Typography>}
          <IconButton color="inherit" aria-controls="simple-menu" aria-haspopup="true" onClick={this.handleIconClick}>
            <AccountCircleIcon color={!user.email ? 'inherit' : 'primary'} />
          </IconButton>
          <Menu
            id="simple-menu"
            anchorEl={this.state.anchorMenuEl}
            keepMounted
            open={Boolean(this.state.anchorMenuEl)}
            onClose={this.handleMenuClose}
          >
            <MenuItem onClick={this.handleMenuClick} href="/mon-compte/profil">
              {t('mon-profil')}
            </MenuItem>
            <MenuItem onClick={this.handleMenuClick} href="/mon-compte/seances">
              {t('mes-seances')}
            </MenuItem>
            <MenuItem onClick={this.handleMenuClick} href="/mon-compte/vod">
              {t('mes-locations-vod')}
            </MenuItem>
            <MenuItem onClick={this.handleMenuClick} href="/mon-compte/localisation">
              {t('ma-localisation')}
            </MenuItem>
            <MenuItem onClick={this.handleMenuClick} href="/cgv">
              {t('conditions-générales-de-ventes')}
            </MenuItem>
            <MenuItem onClick={this.handleMenuClick} href="/about">
              {t('a-propos')}
            </MenuItem>
            <MenuItem onClick={this.handleDisconnect}>{t('deconnexion')}</MenuItem>
          </Menu>
          <LanguageSelector appState={appState} />
        </Toolbar>
        <LoginRegisterComponent
          open={this.state.loginRegisterOpen}
          onClose={this.handleLoginRegisterClose}
          appState={appState}
          methods={methods}
        />
      </AppBar>
    );
  }
}

Topbar.contextType = Context;

export default withTranslation()(Topbar);
